import { Type } from 'class-transformer';
import * as moment from 'moment-timezone';
import { KeyValueResultDto } from '../../../../../_models/key-value-result-dto';
import { DimensionSelectorResultDto } from '../../common/dimensions/dimension-selector-result-dto';
import { GLAccountSelectorResultDto } from '../../common/gl-account/glaccount-selector-result-dto';
import { ARPaymentRawDto } from './ar-payment-raw-dto';

export class ARPaymentEditorResultDto {
    @Type(() => ARPaymentRawDto)
    paymentInfo: ARPaymentRawDto;
    @Type(() => KeyValueResultDto)
    paymentTypes: KeyValueResultDto[];
    @Type(() => KeyValueResultDto)
    subLedgers: KeyValueResultDto[];
    @Type(() => Date)
    closedBookPeriod: Date;
    @Type(() => DimensionSelectorResultDto)
    dimensions: DimensionSelectorResultDto[];

    @Type(() => GLAccountSelectorResultDto)
    glAccounts: GLAccountSelectorResultDto[];

    allowUpdateDimensions: boolean;
    allowUpdateDocumentNumber: boolean;
    allowUpdateAmount: boolean;
    allowUpdatePostDate: boolean;
    allowUpdateSubLedger: boolean;
    allowUpdateGLAccountNumber: boolean;

    // NOTE:- If UndepositedFundAccountNumber is not available in GL account number source then show error message with OK button.
    // “<UndepositedFundAccountNumber> GL Account is not enabled and used as “Undeposited Fund Account”, Please check Entity-Configuration."
    undepositedFundAccountNumber: string;

    get minPostDate(): Date {
        return !!this.closedBookPeriod ? moment(this.closedBookPeriod).add(1, 'day').toDate() : null;
    }
}
